import { render, staticRenderFns } from "./comment-on-video-list.html?vue&type=template&id=15982130&scoped=true&external"
import script from "./comment-on-video-list.js?vue&type=script&lang=js&external"
export * from "./comment-on-video-list.js?vue&type=script&lang=js&external"
import style0 from "./comment-on-video-list.scss?vue&type=style&index=0&id=15982130&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15982130",
  null
  
)

export default component.exports